import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { InfoIcon } from "lucide-react";

export default function InfoLinkDialog({
  buttonLabel,
  title,
  children,
}: {
  buttonLabel: string;
  title: string;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  function handleOpenChange(newValue: boolean) {
    setIsOpen(newValue);
  }

  return (
    <>
      <Button
        variant={"link"}
        size={"linkLg"}
        onClick={() => handleOpenChange(true)}
      >
        <InfoIcon className="mr-2" />
        {buttonLabel}
      </Button>
      <Dialog
        open={isOpen}
        onOpenChange={(open: boolean) => handleOpenChange(open)}
      >
        <DialogTrigger asChild></DialogTrigger>
        <DialogContent className="w-full min-w-[600px]">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{children}</DialogDescription>
          </DialogHeader>
          <div className="flex justify-center pt-0">
            <Button
              variant="blue"
              className="w-64"
              onClick={() => handleOpenChange(false)}
            >
              Got it!
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
